import { PropsWithChildren } from 'react';

export type TagType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type LevelType = 1 | 2 | 3 | 4 | 5 | 6;

export type HeadingHelperProps = PropsWithChildren<{
    level: LevelType;
    classList?: string;
}>;

export const HeadingHelper = ({ level, classList, children }: HeadingHelperProps) => {
    const Tag = `h${level}` as TagType;

    return <Tag className={classList}>{children}</Tag>;
};
